<template>
  <div>
    <b-row>
      <b-col sm="4" class="mx-auto">
        <b-form-group
          label-size='lg'
          label-text-align="left"
          label-class='addpersonlabel'
          label=""
          label-for="assessmentIndicatorFilter"
        >
            <b-form-select
            size="lg"
            id="assessmentIndicatorFilter"
            v-model="assessmentIndicatorFilter"
            :options="assessmentIndicatorFilterOptions"
            >
            <option slot="first" :value="null">Choose...</option>
            </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <horizontal-bar-chart
        class="chart-wrapper"
        style="height: 600px"
        :apiData="sortedAssessmentIndicators"
        :labels="getAssessmentIndicatorLabels(this.sortedAssessmentIndicators, this.assessmentFields, 'field')"
        chartName="Top Indicators"
        :fieldData="assessmentFields"
        valueField="value"
    ></horizontal-bar-chart>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HorizontalBarChart from '../charts/HorizontalBarChart'

export default {
  components: {
    HorizontalBarChart
  },
  created () {
    this.getAssessmentIndicators()
  },
  data: function () {
    return {
      'assessmentIndicatorFilter': 'All',
      'assessmentIndicatorFilterOptions': {
        'All': 'All People',
        'dmst_conclusion': 'Possible Victims',
        'b_confirmed': 'Confirmed Victims'
      }
    }
  },
  computed: {
    ...mapGetters({
      assessmentIndicators: 'getAssessmentIndicators',
      assessmentFields: 'getAssessmentFields'
    }),
    sortedAssessmentIndicators: function () {
      var data = _.clone(this.assessmentIndicators)

      let indexOfTotal = _.findIndex(data, (p) => p.field === 'total')

      if (indexOfTotal >= 0) {
        data.splice(indexOfTotal, 1)
      }

      const orderedData = _
        .chain(data)
        .filter(l => { return l.value && l.value > 0 })
        .orderBy(['value'], ['desc'])
        .value()

      return orderedData
    }
  },
  watch: {
    assessmentIndicatorFilter: function (newValue) {
      this.getAssessmentIndicators()
    }
  },
  methods: {
    getAssessmentIndicators () {
      let params = {}

      // console.log(this.assessmentIndicatorFilter)

      if (this.assessmentIndicatorFilter === 'b_confirmed') {
        params.b_confirmed = 'Yes'
      }

      if (this.assessmentIndicatorFilter === 'dmst_conclusion') {
        params.dmst_conclusion = true
      }

      this.$store.dispatch('getAssessmentIndicators', params)
    },
    getAssessmentIndicatorLabels (data, fieldData, field, indicator) {
      let labels = []
      var labelData

      const first = fieldData[0]

      if (first.hasOwnProperty('groupByValue')) {
        labelData = data
      }

      if (!first.hasOwnProperty('groupByValue')) {
        if (!_.isUndefined(data)) {
          labelData = _.uniq(_.map(data, 'field'))
        }
      }

      const apiLabels = _
        .chain(labelData)
        .value()

      // console.log(apiLabels)
      // field name to label matching
      _.forEach(apiLabels, (apiLabel) => {
        const matchingField = _.find(fieldData, (f) => {
          return f.name === apiLabel
        })

        if (matchingField) {
          labels.push(matchingField.label)
        } else {
          labels.push(apiLabel)
        }
      })

      return labels
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/charts/AssessmentIndicators.vue